$(() => {
  $('.hero__slider').slick({
    adaptiveHeight: true,
    dots: true,
    prevArrow: '<div class="hero__slider-arrow hero__slider-arrow--prev"><span class="svg-icon svg-icon--i-chevron-left"><svg xmlns="http://www.w3.org/2000/svg" class="svg-icon__glyph" role="img"><use xlink:href="#i-chevron-left"></use></svg></span>',
    nextArrow: '<div class="hero__slider-arrow hero__slider-arrow--next"><span class="svg-icon svg-icon--i-chevron-right"><svg xmlns="http://www.w3.org/2000/svg" class="svg-icon__glyph" role="img"><use xlink:href="#i-chevron-right"></use></svg></span>'
  });

  $('.scroll-block').mCustomScrollbar({
    scrollButtons: {
      enable: true
    },
    scrollEasing: "linear"
  });

  function hideNav(e) {
    $('body').removeClass('shown-nav');
    return true
  }

  $('.header__nav').on('click', hideNav);
  $('.header__toggle').on('click', function() {
    $('body').toggleClass('shown-nav')
  });

  function togglerHandler(e) {
    e.preventDefault();
    const block = $(this).closest('.toggler');
    
    if (block.length === 0) {
      throw new Error('parent node .toggler is required');
    }
    const content = block.find('.toggler__content');
    if (content.length === 0) {
      throw new Error('parent node .toggler should contain .toggler__content node');
    };

    const isActive = block.hasClass('is-active');

    if (isActive) {
      content.stop(true, true).slideUp(300, () => {
        block.removeClass('is-active')
      })
    } else {
      content.stop(true, true).slideDown(300, () => {
        block.addClass('is-active')
      })
    }
  }

  $('.toggler__title').on('click', togglerHandler);
  $('input[type="tel"]').mask('+7 (999)-999-99-99');

  const nawWrapper = $('.header');
  const navOffsetTop = nawWrapper.offset().top + 200;

  if ($('.header__placeholder').length === 0) {
    $('.header').after('<div class="header__placeholder"></div>');
    $('.header__placeholder').css({ height: nawWrapper.outerHeight() })
  }

  $(window).on('scroll', () => {
    if ($(window).scrollTop() > navOffsetTop) {
      $('.header').addClass('is-sticky')
    } else {
      $('.header').removeClass('is-sticky')
    }
  });

  $('.wysiwyg table').each((idx, el) => {
    if(!$(el).parent().hasClass('table-wrapper')) {
      $(el).wrap('<div class="table-wrapper"></div>')
    }
  });

  function cardClickHandler (e) {
    e.preventDefault();
    const img = $(this).attr('data-img');
    if (!img) return;

    $.fancybox.open({
      src: img,
      type: 'image'
    })
  }

  $('.device-card__image').on('click', cardClickHandler)

});
